import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_ALLERGENS_MUTATION } from '../graphql/mutations'
import { transformToSaveAllergensArgs } from '../graphql/transformers'
import { SAVE_ALLERGENS } from '../redux/action-types'

const useSaveAllergensMutation = refetchLastEvent => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.allergens.allergens)

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_ALLERGENS_MUTATION,
        { data: transformToSaveAllergensArgs(data) },
        dispatch,
        SAVE_ALLERGENS,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveAllergensMutation
